import api from "@/services/api";
import { familyGroupErrorMessage } from "@/services/credential";

/**
 * @module services/family-group
 * @description UC-REG-295 — Grupo familiar autogestionado por el paciente
 *   (`/family-group/me`, solo tenants con `FAMILY_GROUP_SELF_MANAGED` en la
 *   API). Las respuestas traen `{ holder, isHolder, members[] }`.
 */
const familyGroupService = {};

const endpoint = "/family-group/me";

/** @description Opciones comunes: traduce los códigos de error de la API. */
const requestOptions = { getErrorMessage: familyGroupErrorMessage };

/**
 * @description Grupo familiar del paciente logueado.
 * @param {Object} [options] - opciones de la request (ej. `getErrorMessage`)
 * @returns {Promise<{holder: Object, isHolder: boolean, members: Array<Object>}>}
 */
familyGroupService.getMe = function (options = {}) {
  return api
    .get(endpoint, { ...requestOptions, ...options })
    .then((res) => res.data);
};

/**
 * @description Agrega un integrante al grupo del titular.
 * @param {Object} data - { firstName, lastName, dni, bornAt, gender?, type }
 * @returns {Promise<Object>} grupo actualizado
 */
familyGroupService.addMember = function (data) {
  return api
    .post(`${endpoint}/members`, data, requestOptions)
    .then((res) => res.data);
};

/**
 * @description Edita un integrante (parentesco siempre; datos personales solo
 *   si no tiene cuenta propia).
 * @param {string} userId - _id del integrante
 * @param {Object} data - { firstName?, lastName?, bornAt?, gender?, type? }
 * @returns {Promise<Object>} grupo actualizado
 */
familyGroupService.updateMember = function (userId, data) {
  return api
    .put(`${endpoint}/members/${userId}`, data, requestOptions)
    .then((res) => res.data);
};

/**
 * @description Saca a un integrante del grupo (no borra su historia clínica).
 * @param {string} userId - _id del integrante
 * @returns {Promise<Object>} grupo actualizado
 */
familyGroupService.removeMember = function (userId) {
  return api
    .delete(`${endpoint}/members/${userId}`, requestOptions)
    .then((res) => res.data);
};

export default familyGroupService;
